import { render, staticRenderFns } from "./cadastro_paciente.vue?vue&type=template&id=4aaa1ab4&scoped=true"
import script from "./cadastro_paciente.vue?vue&type=script&lang=js"
export * from "./cadastro_paciente.vue?vue&type=script&lang=js"
import style0 from "./cadastro_paciente.vue?vue&type=style&index=0&id=4aaa1ab4&prod&lang=css"
import style1 from "./cadastro_paciente.vue?vue&type=style&index=1&id=4aaa1ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa1ab4",
  null
  
)

export default component.exports